import { useTranslation } from "react-i18next";
import DiaryValuesLineChart from "../diary/DiaryValuesLineChart";

const normalizeParamKey = (value) =>
  (value || "").toString().trim().toLowerCase().replace(/[\s-]+/g, "_");

const getOrCreateEntry = (entries, key, createEntry) => {
  let existing = entries.find((entry) => entry?.sourceKey === key);

  if (!existing) {
    existing = createEntry();
    entries.push(existing);
  }

  return existing;
};

const transformMeasurementsToDataSets = (measurements, t) => {
  const transformedData = [];

  measurements?.forEach((measurement) => {
    const measurementKey = normalizeParamKey(measurement?.name);
    const measurementLabel = t(measurement?.name);
    const parameterMap = (measurement?.params || []).reduce((acc, param) => {
      acc[normalizeParamKey(param?.name)] = param;
      return acc;
    }, {});

    if (measurementKey === "blood_pressure") {
      const systoleParam = parameterMap?.systole;
      const diastoleParam = parameterMap?.diastole;
      const pulseParam = parameterMap?.pulse;

      const pulseValue = pulseParam ? parseFloat(pulseParam?.value) : NaN;
      const pulseUnit = pulseParam?.unit ? t(pulseParam?.unit) : "";
      const pulseInfo = Number.isFinite(pulseValue)
        ? { label: t("pulse"), value: pulseValue, unit: pulseUnit }
        : null;

      [systoleParam, diastoleParam].forEach((param) => {
        const value = parseFloat(param?.value);

        if (!param || !Number.isFinite(value)) {
          return;
        }

        const paramKey = normalizeParamKey(param?.name);
        const entry = getOrCreateEntry(
          transformedData,
          paramKey,
          () => ({
            label: t(param?.name),
            sourceKey: paramKey,
            measurementKey,
            measurementLabel,
            data: [],
            connectPoints: true,
          }),
        );

        entry?.data?.push({
          x: measurement?.dateTime,
          y: value,
          value,
          unit: param?.unit ? t(param?.unit) : "",
          extraValues: pulseInfo ? [pulseInfo] : [],
        });
      });

      return;
    }

    measurement?.params?.forEach((param) => {
      const paramName = param?.name;
      const value = parseFloat(param?.value);

      if (!Number.isFinite(value)) {
        return;
      }

      const paramKey = normalizeParamKey(paramName);
      const unit = param?.unit ? t(param?.unit) : "";

      const existingEntry = getOrCreateEntry(
        transformedData,
        paramKey,
        () => ({
          label: t(paramName),
          sourceKey: paramKey,
          measurementKey,
          measurementLabel,
          data: [],
          connectPoints: true,
        }),
      );

      existingEntry?.data?.push({
        x: measurement?.dateTime,
        y: value,
        value,
        unit,
      });
    });
  });

  return transformedData;
};

const MeasurementsLineChart = ({
  measurements,
  patientId,
  onCloseDialog,
  showDialog,
}) => {
  const { t } = useTranslation();
  const values = transformMeasurementsToDataSets(measurements, t);

  return (
    <DiaryValuesLineChart
      header={t("measurements_line_chart")}
      values={values}
      showDialog={showDialog}
      onCloseDialog={onCloseDialog}
      patientId={patientId}
    />
  );
};

export default MeasurementsLineChart;
